import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
import cx from 'classnames';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Hidden from '@material-ui/core/Hidden';

// material-ui icons
import Menu from '@material-ui/icons/Menu';
import MoreVert from '@material-ui/icons/MoreVert';
import ViewList from '@material-ui/icons/ViewList';

// core components
import AdminNavbarLinks from './AdminNavbarLinks';
import AlertsIndicator from 'components/AlertsIndicator/AlertsIndicator';
import Button from 'components/CustomButtons/Button';
import BackIcon from 'assets/img/back.svg';

import styles from 'assets/jss/material-dashboard-pro-react/components/adminNavbarStyle';

const useStyles = makeStyles(styles);

export default function AdminNavbar(props) {
	const classes = useStyles();
	const { color, brandText } = props;
	const appBarClasses = cx({
		[' ' + classes[color]]: color,
	});

	const sidebarMinimize = classes.sidebarMinimize;

	const backAllowed =
		props.location.pathname?.split('/').filter((segment) => segment)
			.length > 2 && !props.location.state?.disableBack;

	return (
		<AppBar className={classes.appBar + appBarClasses}>
			<Toolbar className={classes.container}>
				<Hidden smDown implementation="css">
					<div className={sidebarMinimize}>
						{props.miniActive ? (
							<Button
								justIcon
								round
								color="white"
								onClick={props.sidebarMinimize}
							>
								<ViewList className={classes.sidebarMiniIcon} />
							</Button>
						) : (
								<Button
									justIcon
									round
									color="white"
									onClick={props.sidebarMinimize}
								>
									<MoreVert className={classes.sidebarMiniIcon} />
								</Button>
							)}
					</div>
				</Hidden>
				<div className={classes.flex}>
					{backAllowed && (
						<img
							src={BackIcon}
							alt="back"
							className={classes.backIcon}
							onClick={props.goBack}
						/>
					)}
					{/* Here we create navbar brand, based on redux value */}
					<span className={classes.pageHeader}>{brandText}</span>
				</div>
				<Hidden smDown implementation="css">
					<AlertsIndicator />
				</Hidden>
				<Hidden smDown implementation="css">
					<AdminNavbarLinks />
				</Hidden>
				<Hidden mdUp implementation="css">
					<Button
						className={classes.appResponsive}
						color="transparent"
						justIcon
						aria-label="open drawer"
						onClick={props.handleDrawerToggle}
					>
						<Menu />
					</Button>
				</Hidden>
			</Toolbar>
		</AppBar>
	);
}

AdminNavbar.propTypes = {
	color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
	brandText: PropTypes.string,
	miniActive: PropTypes.bool,
	handleDrawerToggle: PropTypes.func,
	sidebarMinimize: PropTypes.func,
	location: PropTypes.object,
	goBack: PropTypes.func,
};
